"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromoStrip;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
var _actions = _interopRequireDefault(require("../../../elements/other/actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StripSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "StripSection",
  class: "pl-syl5tk6"
});
const PromoContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PromoContent",
  class: "pl-p9m19g9"
});

/**
 * Promo Banner Component
 * @module PromoStrip
 *
 * @param {Object} props React props
 * @param {string} props.id The component's id
 * @param {React.ReactNode} props.tag Tag Element
 * @param {Object} props.headline The banner's copy
 * @param {string} props.cta The banner's call to action button
 * @returns {React.ReactElement} Promo Banner Component
 * @public
 */
function PromoStrip({
  id,
  tag,
  headline,
  cta,
  partial,
  dismissable = false
}) {
  const [showStrip, setShowStrip] = (0, _react.useState)(true);
  return showStrip && /*#__PURE__*/_react.default.createElement(StripSection, {
    id: id,
    dataCy: "promo-strip",
    className: "promo-strip",
    partial: partial,
    margin: "none",
    textAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(PromoContent, {
    className: "promo-content"
  }, tag, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: headline
  }), cta && /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: [cta]
  })), dismissable && /*#__PURE__*/_react.default.createElement("div", {
    className: "close-btn-spacer"
  }, /*#__PURE__*/_react.default.createElement(_closeButton.default, {
    onClose: () => setShowStrip(false),
    className: "close-promo-strip"
  })));
}
PromoStrip.propTypes = {
  id: _propTypes.default.string,
  tag: _propTypes.default.node,
  headline: _propTypes.default.string,
  cta: _propTypes.default.node,
  partial: _propTypes.default.string,
  dismissable: _propTypes.default.bool
};